import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import SummaryDetail from './SummaryDetail';
import InfoAndPayment from './InfoAndPayment';
import EditDesign from './EditDesign';
import ContainerWithPadding from './ContainerWithPadding';
import { LeaseContextProvider } from './LeaseContext';

export default function SummarySidebar(props) {
  const { configurationSummary, onSaveClick, onPaymentClick, onUpdateClick, newOrder } = props;

  return (
    <Container>
      <ContainerWithPadding>
        <EditDesignContainer>
          <EditDesign />
        </EditDesignContainer>
        <LeaseContextProvider>
          <SummaryDetail summary={configurationSummary} />
        </LeaseContextProvider>
      </ContainerWithPadding>
      <InfoAndPayment
        dueAmount={configurationSummary?.dueAmount}
        onSaveClick={onSaveClick}
        onPaymentClick={onPaymentClick}
        onUpdateClick={onUpdateClick}
        newOrder={newOrder}
      />
    </Container>
  );
}

const Container = styled(Box)(({ theme }) => ({
  paddingTop: '66px',

  // override autofill color
  '& input': {
    '&:autofill': {
      boxShadow: '0 0 0 1000px #F4F4F4 inset'
    }
  },

  [theme.mediaQueries.md]: {
    minWidth: '400px',
  }
}));

const EditDesignContainer = styled(Box)(({ theme }) => ({
  paddingTop: '24px',

  [theme.mediaQueries.md]: {
    paddingTop: '0px',
  }
}))
